import { useCallback, useEffect, useState } from 'react';
import { changesApi } from '../../../services/changesApi';
import { getApiErrorMessage } from '../../../utils/apiError';

export interface ChangeAttachment {
  id: number;
  filename: string;
  file_path: string;
  file_size?: number | null;
  mime_type?: string | null;
  description?: string | null;
  uploaded_at: string;
}

export function useChangeAttachments(changeId: number, enabled: boolean) {
  const [attachments, setAttachments] = useState<ChangeAttachment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!changeId || !enabled) return;
    setLoading(true);
    try {
      const response = await changesApi.listAttachments(changeId);
      setAttachments(Array.isArray(response.items) ? response.items : []);
      setError(null);
    } catch (err: unknown) {
      setAttachments([]);
      setError(getApiErrorMessage(err, 'Não foi possível carregar os anexos.'));
    } finally {
      setLoading(false);
    }
  }, [changeId, enabled]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { attachments, loading, error, reload };
}
